import { useQuery } from "@tanstack/react-query";

import { authGet } from "@shared/api";
import { NOTIFICATIONS_URL } from "@shared/constants";
import { TicketingInstance } from "@shared/types";

import { useOrgAssertDefined } from "../useOrgAssertDefined";

// fetches the primary ticketing instance for a deployment
// only fetches the first ticketing instance
// returns null if there is no ticketing instance (hasn't been configured)
export const fetchPrimaryTicketingInstance = async (
  deploymentId: number
): Promise<TicketingInstance | null> => {
  return authGet<TicketingInstance[]>(
    `${NOTIFICATIONS_URL}/${deploymentId}/ticketing`
  ).then((res) => (res.length > 0 ? res[0] : null));
};

export const usePrimaryTicketingInstance = () => {
  const org = useOrgAssertDefined();

  return useQuery({
    queryKey: ["PrimaryTicketingInstance", { org }],
    queryFn: () => fetchPrimaryTicketingInstance(org.id),
  });
};
